import React from 'react';
import { Box, SvgIcon, Button } from '@agilize/components-core';
import { Description404, DetectiveContainer, H1, H2, ErrorPageSection, P, ButtonsContainer } from './ErrorPage.styles';

const ErrorPage = () => (
  <Box display="flex" justifyContent="center" alignItems="center" width="100%" minHeight="100vh">
    <ErrorPageSection>
      <Box display="flex" flexDirection={['column', 'row']} width="100%">
        <Description404>
          <H1>Vixe...</H1>
          <H2>Parece que algo deu errado</H2>
          <P>Ocorreu um erro na aplicação, mas não se preocupe: nossa equipe já foi notificada e iremos resolver o mais rápido possível</P>
          <P>Por favor, tente novamente ou volte para o dashboard</P>

          <ButtonsContainer>
            <Box mt={3} mb={2}>
              <Button onClick={() => document.location.reload()} type="button">
                Tentar novamente
              </Button>
            </Box>
            <Button
              onClick={() => {
                document.location.href = '/';
              }}
              type="button"
              color="secondary">
              Voltar para o dashboard
            </Button>
          </ButtonsContainer>
        </Description404>
        <DetectiveContainer>
          <SvgIcon src={`${process.env.APP_PATH}public/assets/icons/custom/error-page-log.svg`} />
        </DetectiveContainer>
      </Box>
    </ErrorPageSection>
  </Box>
);

export default ErrorPage;
